import React from "react";

export default function PriceCompnent({
  children,
  styles,
  btnStyle,
  price = "$0",
  btnName = "Start Free Trial",
  plan = "free",
}) {
  return (
    <div className={`p-[32px]  w-[22.5em] rounded-3xl ${styles}`}>
      <h3 className="text-black text-[2.25rem] font-medium capitalize">
        {plan}
      </h3>
      <p className="text-black text-[1rem]">Special first packet for all</p>

      <div className="flex flex-col h-[80%] justify-between">
        <div>
          <hr className="border border-black my-[2em]" />

          <p className="text-black text-[18px]">
            <span className="text-5xl font-bold">{price}</span>
            /Month
          </p>
          {children}
        </div>
        <button
          className={`w-[18.5em] p-3 bg-green-400 rounded-full ${btnStyle} self-end`}
        >
          {btnName}
        </button>
      </div>
    </div>
  );
}
